import { Link } from "@tanstack/react-router";
import type { FC, ReactNode } from "react";
import styles from "@/layouts/AppLayout/NavItem.module.css";

interface NavItemProps {
  collapsed?: boolean;
  icon: ReactNode;
  label: string;
  to: string;
}

const NavItem: FC<NavItemProps> = ({ collapsed, icon, label, to }) => (
  <Link
    activeOptions={{ exact: true }}
    activeProps={{ className: styles.active }}
    aria-label={collapsed ? label : undefined}
    className={`${styles.item}${collapsed ? ` ${styles.collapsed}` : ""}`}
    data-label={collapsed ? label : undefined}
    to={to}
  >
    <span className={styles.icon}>{icon}</span>
    <span aria-hidden={collapsed} className={styles.label}>
      {label}
    </span>
  </Link>
);

export default NavItem;
